import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import Loader from 'components/Loader'
import { RoutePaths } from 'containers/Core/Routes'

const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0()

  useEffect(() => {
    loginWithRedirect({
      redirectUri: window.location.origin + RoutePaths.DASHBOARD,
    })
  }, [])

  return <Loader />
}

export default Login
